'use client'

import React from 'react'
import { CollectionArchive } from '@/ui/components/CollectionArchive'
import { BaseGatedArchiveClientProps } from '@/ui/blocks/shared/gatedArchiveTypes'
import { CardType } from '@/ui/components/Card/types'
import { mapArticlesToCardProps } from './mapper'
import { SortingOption } from '@/ui/components/SortBy'

/**
 * Props for ArticlesArchiveClient
 */
export interface ArticlesArchiveClientProps extends BaseGatedArchiveClientProps {
  /** Sorting options for the archive */
  sortingOptions?: SortingOption[]
}

/**
 * Client component for ArticlesArchive
 *
 * Simplified client component that delegates all logic to CollectionArchive.
 * All gating, authentication, and rendering logic is now handled by the
 * generic CollectionArchive component.
 */
export const ArticlesArchiveClient: React.FC<ArticlesArchiveClientProps> = ({
  initialData,
  fetchCollectionDataAction,
  isGated,
  gateConfig,
  where,
  locale,
  limit,
  gridCols,
  filters = [],
  filterField = 'articleType',
  filterTitle,
  title,
  introContent,
  archiveId = 'articles',
  titleHierarchy = 'h2',
  fixedTitleStyle,
  sortingOptions,
  emptyStateType,
  emptyStateButton,
  emptyStateHasButton,
}) => {
  // All logic delegated to CollectionArchive
  return (
    <CollectionArchive
      archiveId={archiveId}
      initialData={initialData}
      fetchCollectionDataAction={fetchCollectionDataAction}
      collection="articles"
      locale={locale}
      where={where}
      limit={limit}
      gridCols={gridCols}
      filter={filters}
      filterField={filterField}
      filterTitle={filterTitle}
      cardType={CardType.StandardFavorite}
      mapper={mapArticlesToCardProps}
      title={title ?? undefined}
      titleHierarchy={titleHierarchy ?? 'h2'}
      fixedTitleStyle={fixedTitleStyle}
      //introContent={introContent}
      loadMoreStrategy="pagination"
      sortingOptions={sortingOptions}
      // Gating props
      isGated={isGated}
      gateConfig={gateConfig}
      // Empty state props
      emptyStateType={emptyStateType}
      emptyStateButton={emptyStateButton}
      emptyStateHasButton={emptyStateHasButton}
    />
  )
}
